import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCheck } from 'lucide-react';
import { formatTimeHMMA } from '@/util/utils';
export const DeliverInfo = ({ chatEvent }) => {
    if (chatEvent.event_type === 'user_message') {
        const time = new Date(chatEvent.created_at);
        const formattedTime = formatTimeHMMA(time);
        return (_jsxs("div", { className: "text-foreground-muted ml-auto flex items-center gap-2 px-1 text-xs", children: [_jsx("span", { className: "whitespace-nowrap uppercase", children: formattedTime }), chatEvent.delivered_at && (_jsx(CheckCheck, { size: 16, color: chatEvent.read_at
                        ? 'var(--color-successful)'
                        : 'var(--color-foreground-muted)' }))] }));
    }
    throw new Error("Shouldn't be reachable");
};
